

















import * as _ from "lodash";
import moment from "moment";
import { reactive, ref, Ref, SetupContext, defineComponent, onMounted, PropType, watch } from '@vue/composition-api';
import * as D from "@/models/draggable"
import * as Auth from "@/models/auth";
import * as F from "@/formatter"
import * as FB from "@/models/fb";

export default defineComponent({
  props: {
    auth_state: {
      type: Object as PropType<Auth.AuthState>,
      required: true,
    },
  },

  setup(props: {
    auth_state: Auth.AuthState;
  }, context: SetupContext) {
    const lister = FB.useObjectLister(context, user => D.spawn_lister(user));
    onMounted(() => {
      if (props.auth_state.user) {
        lister.changed_user(props.auth_state)
      }
    });
    watch(() => props.auth_state.user, () => lister.changed_user(props.auth_state))
    return {
      ...lister,
      ...F.useFormatter(),
      view_item: (item: D.GrabDAGHead) => {
        context.root.$router.push(`/dag/${item.id}`)
      },
      new_item: () => {
        const item = D.new_dag();
        context.root.$router.push(`/dag/${item.id}`)
      },
    };
  },
});
